import format from "date-fns/format";
import React from "react";
import { FormattedMessage } from "react-intl";
import prettyDate from "../../helpers/prettyDate";

type FormattedDateBadgesProps = {
  start: Date;
  end: Date;
  dateFormat: string;
  text: string;
  includeClockOnEqual?: boolean;
  isFullDay?: boolean;
};

const overrideFormat = (dateFormat: string): string => {
  switch (dateFormat) {
    case "start_end_date_and_time":
    case "start_date_and_time":
      return "start_date_and_time";
    case "free_text":
      return "free_text";
    default:
      return "start_date";
  }
};

const FormattedDateHelper: React.FC<FormattedDateBadgesProps> = ({
  start,
  end,
  dateFormat,
  text,
  includeClockOnEqual = true,
  isFullDay = false,
}) => {
  const overriddenFormat = isFullDay ? overrideFormat(dateFormat) : dateFormat;
  return (
    <span>
      {overriddenFormat === "start_end_date_and_time" && prettyDate(start) !== prettyDate(end) && (
        <FormattedMessage
          id={"screens.Complete.to"}
          defaultMessage={"{startDate} to {endDate}"}
          values={{
            startDate: prettyDate(start) + " " + format(start, "HH:mm"),
            endDate: prettyDate(end),
          }}
        />
      )}
      {overriddenFormat === "start_end_date_and_time" &&
        prettyDate(start) === prettyDate(end) &&
        includeClockOnEqual && (
          <FormattedMessage
            id={"screens.Complete.to"}
            defaultMessage={"{startDate} to {endDate}"}
            values={{
              startDate: prettyDate(start) + " " + format(start, "HH:mm"),
              endDate: format(end, "HH:mm"),
            }}
          />
        )}
      {overriddenFormat === "start_end_date_and_time" &&
        prettyDate(start) === prettyDate(end) &&
        !includeClockOnEqual &&
        prettyDate(start)}
      {overriddenFormat === "start_date_and_time" &&
        prettyDate(start) + " " + format(start, "HH:mm")}
      {overriddenFormat === "start_date" && prettyDate(start)}
      {overriddenFormat === "start_end_date" && prettyDate(start) !== prettyDate(end) && (
        <FormattedMessage
          id={"screens.Complete.to"}
          defaultMessage={"{startDate} to {endDate}"}
          values={{
            startDate: prettyDate(start),
            endDate: prettyDate(end),
          }}
        />
      )}
      {overriddenFormat === "start_end_date" &&
        prettyDate(start) === prettyDate(end) &&
        prettyDate(start)}
      {overriddenFormat === "free_text" && text}
    </span>
  );
};

export default FormattedDateHelper;
